export default {
  // eslint-disable-next-line func-names
  bind: function (el, binding, vnode) {
    // eslint-disable-next-line func-names
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  // eslint-disable-next-line func-names
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};
